import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { getIcon } from "../lib/icons";

const ServiceCard = ({ service, index = 0 }) => {
  const navigate = useNavigate();
  const Icon = getIcon(service.icon);

  return (
    <motion.article
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.1 }}
      onClick={() => navigate(`/services/${service.slug}`)}
      className="group relative flex flex-col h-full cursor-pointer rounded-2xl border border-border bg-card p-8 transition-all duration-300 hover:-translate-y-2 hover:border-primary/40 hover:shadow-xl hover:shadow-primary/10"
    >
      <div className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-xl bg-brand-gradient text-white shadow-lg shadow-primary/20">
        <Icon className="h-7 w-7" />
      </div>

      <h3 className="font-display text-xl font-semibold text-foreground">
        {service.name}
      </h3>
      <p className="mt-2 text-sm text-muted-foreground">{service.tagline}</p>

      <ul className="mt-5 space-y-2">
        {service.features.slice(0, 5).map((feature) => (
          <li key={feature} className="flex items-center gap-2 text-sm text-foreground/80">
            <Check className="h-4 w-4 shrink-0 text-accent" />
            {feature}
          </li>
        ))}
      </ul>

      <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary transition-all group-hover:gap-2.5">
        Explore service
        <ArrowRight className="h-4 w-4" />
      </span>
    </motion.article>
  );
};

export default ServiceCard;
